module.exports = __webpack_public_path__ + "assets/img/9.b8b0b8bd.png";